export default {
  methods: {
    async render_pie(data) {
      let seriesData = data && data.length ? data.map(v=>{
        return {
          name: v.name,
          value: v.visitNum,
          proportion: v.proportion
        }
      }) : []
      let option = {
        color: ['#F59B23', '#0097F8', '#3EDBA8',],
        title: {
          text: "用户性别分布",
          x: "left",
          y: "top",
          left: 10,
          textStyle: {
            fontWeight: "normal",
            fontSize: 16,
          },
          z: 1,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: "10%",
          top: "center",
          itemGap: 30,
          selectedMode: false,
          icon: "pin",
          data: ["男", "女", "未知"],
          textStyle: {
            color: "#77899c",
            rich: {
              uname: {
                width: 30,
              },
              unum: {
                width: 100,
                align: "center",
              },
            },
          },
          formatter(name) {
            let nameLsit = seriesData.map(v=>v.name)
            let index = nameLsit.indexOf(name)
            return `{uname|${name}}{unum|数量：${seriesData[index].value || 0}}{unum|占比：${seriesData[index].proportion || 0}%}`;
          },
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: [60, 90],
            center: ["30%", "50%"],
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              borderWidth: 3,
              borderColor: "#fff",
            },
            data: seriesData,
          },
        ],
      };
      let $instance = this.$echarts.init(this.$refs['pieChats']);
      $instance.setOption(option, true);
      $instance.on('click', params => {
        this.dialogFormVisibleLeft = true
        this.leftDialog(colorArr)
      });
    }
  }
}